
import axios from "@/utils/axios";
import { asArray } from "@/utils/apiResponse";

const API_URL = process.env.VUE_APP_API_URL || "";

export const getProfile = async () => {
  const response = await axios.get(`${API_URL}/profile/`);
  return response.data?.data || response.data;
};

export const updateUser = async (id, data) => {
  const response = await axios.put(`${API_URL}/profile/`, data);
  return response.data;
};

export const resetUserPassword = async (id, data) => {
  const response = await axios.post(`${API_URL}/profile/password`, data);
  return response.data;
};

export const verifyEmail = async () => {
  const response = await axios.post(`${API_URL}/profile/send-verification`);
  return response.data;
};

export const uploadProfileImage = async (formData) => {
  const response = await axios.post(`${API_URL}/profile/profile-image`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteProfileImage = async () => {
  const response = await axios.delete(`${API_URL}/profile/profile-image`);
  return response.data;
};

export const getUsers = async () => {
  const response = await axios.get(`${API_URL}/users`);
  return asArray(response.data);
};
